import c from "react";
import { c as e, t as s } from "./app-a75c1d35.mjs";
import { C as E } from "./CallToAction-d24a74ed.mjs";
import { B as n } from "./Block-9b78bd10.mjs";
import { L as g } from "./Link-479ac100.mjs";
import "./Icon-3122c134.mjs";
import "./LinkContext-0c83848a.mjs";
const f = "contact-card", _ = "contact-card--single", x = "contact-card--multiple-first", B = "contact-card--multiple-second", h = "contact-card__title", y = "contact-card--description", S = "contact-card__phone", T = "contact-card__email", P = "contact-card__email--bottom", t = {
  contactCard: f,
  contactCardSingle: _,
  contactCardMultipleFirst: x,
  contactCardMultipleSecond: B,
  contactCardTitle: h,
  contactCardDescription: y,
  contactCardPhone: S,
  contactCardEmail: T,
  contactCardEmailBottom: P
}, L = [
  e(t.contactCardTitle, s.textsComponentTitleBold),
  e(t.contactCardDescription, s.textsLeadText),
  e(t.contactCardPhone, s.textsBodyText)
], M = ({
  title: a,
  description: r,
  phone: l,
  email: o,
  link: d,
  isSecondCard: m = !1,
  isMultipleCard: i = !1
}) => {
  const p = [a, r, l];
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: e(t.contactCard, {
        [t.contactCardSingle]: !i,
        [t.contactCardMultipleFirst]: i && !m,
        [t.contactCardMultipleSecond]: i && m
      })
    },
    p.map((u, C) => /* @__PURE__ */ c.createElement("p", { key: C, className: L[C] }, u)),
    /* @__PURE__ */ c.createElement(g, { href: `mailto:${o}`, disableLinkTextStyle: !0 }, /* @__PURE__ */ c.createElement(
      "p",
      {
        className: e(
          t.contactCardEmail,
          d && t.contactCardEmailBottom
        )
      },
      o
    )),
    d && /* @__PURE__ */ c.createElement(E, { text: "Learn more", to: d, isBlueBackground: !0 })
  );
};
function v({ contacts: a }) {
  const r = a.length > 2 ? a.slice(0, 2) : a;
  return /* @__PURE__ */ c.createElement(n, { topPadding: n.Padding.NONE, bottomPadding: n.Padding.LARGE }, /* @__PURE__ */ c.createElement(n.Content, null, r.map((l, o) => /* @__PURE__ */ c.createElement(
    M,
    {
      key: o,
      ...l,
      isMultipleCard: a.length > 1,
      isSecondCard: o === 1
    }
  ))));
}
export {
  v as ContactCard
};
//# sourceMappingURL=ContactCard.js.map
